import React, { useEffect, useRef } from "react";

const Stores = () => {
  const items = [
    "/img/webpImg/flipkartLogo.webp",
    "/img/webpImg/myntraLogo.webp",
    "/img/webpImg/nykaaLogo.webp",
    "/img/webpImg/tataCliqLogo.webp",
    "/img/webpImg/ajioLogo.webp",
    "/img/webpImg/snapdealLogo.webp",
  ];

  const scrollContainerRef = useRef(null);
  const scrollContentRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    const scrollContent = scrollContentRef.current;

    if (!scrollContainer || !scrollContent) return;

    let animationFrameId;
    let scrollPosition = 0;

    const performScroll = () => {
      // Increase scroll position
      scrollPosition -= 1;

      // Reset scroll position when it exceeds the content width
      if (Math.abs(scrollPosition) >= scrollContent.scrollWidth / 2) {
        scrollPosition = 0;
      }

      // Apply the translation
      scrollContent.style.transform = `translateX(${scrollPosition}px)`;

      // Continue the animation
      animationFrameId = requestAnimationFrame(performScroll);
    };

    // Start the scroll animation
    animationFrameId = requestAnimationFrame(performScroll);

    // Pause on hover
    const handleMouseEnter = () => {
      cancelAnimationFrame(animationFrameId);
    };

    const handleMouseLeave = () => {
      animationFrameId = requestAnimationFrame(performScroll);
    };

    scrollContainer.addEventListener("mouseenter", handleMouseEnter);
    scrollContainer.addEventListener("mouseleave", handleMouseLeave);

    // Cleanup
    return () => {
      cancelAnimationFrame(animationFrameId);
      scrollContainer.removeEventListener("mouseenter", handleMouseEnter);
      scrollContainer.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <div className="flex flex-col sm:gap-6 md:gap-8 lg:gap-10">
      <h2 className="hidden sm:block text-center text-[21px] font-mediumleading-[100%]">
        Fresh loot deals from the top online stores
      </h2>

      <div
        className="infinite-scroll-container-react bg-[#FFF] sm:bg-transparent shadow-customStores sm:shadow-none -rotate-2 sm:rotate-0"
        ref={scrollContainerRef}
      >
        <div
          className="infinite-scroll-content-react h-[43px]  "
          ref={scrollContentRef}
        >
          {[...Array(4)].map((_, repeatIndex) =>
            items.map((item, index) => (
              <div
                key={`item-${repeatIndex}-${index}`}
                className="infinite-scroll-item-react"
              >
                <img
                  src={item}
                  alt="Store icon"
                  className="infinite-scroll-image-react !w-[70px]"
                />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Stores;
